// extracted by mini-css-extract-plugin
module.exports = {"link":"ExternalLink_link__2I1p2"};